import { Camera, Upload, X } from "lucide-react";

const isVideo = (file) => (file?.type || "").startsWith("video/");
const ACCEPT = "image/jpeg,image/png,image/webp,video/mp4,video/quicktime,video/webm";

const PickBtn = ({ icon: Icon, label, capture, onPick, testId }) => (
  <label data-testid={testId} className="flex cursor-pointer items-center gap-1 rounded-lg border border-[#333] px-2.5 py-1.5 text-[11px] font-bold text-white transition-colors hover:border-[#4CCC06]">
    <Icon size={13} />{label}
    <input type="file" accept={capture ? "image/*,video/*" : ACCEPT} capture={capture ? "environment" : undefined} className="hidden"
      onChange={(e) => { const f = e.target.files[0]; e.target.value = ""; if (f) onPick(f); }} />
  </label>
);

export default function MediaSlot({ label, media, onPick, onClear, required, testId }) {
  return (
    <div data-testid={testId} className="flex flex-col gap-2 rounded-lg border border-dashed p-2" style={{ borderColor: media ? "#4CCC06" : "#3a3a3a", background: "#0A0A0A" }}>
      <div className="relative flex items-center justify-center" style={{ height: 120 }}>
        {!media && <span className="text-[11px] text-neutral-400">{label}{required ? " (required)" : ""}</span>}
        {media && (isVideo(media.file)
          ? <video data-testid={`${testId}-preview-video`} src={media.preview} controls playsInline style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 8 }} />
          : <img data-testid={`${testId}-preview-img`} src={media.preview} alt={label} style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 8 }} />)}
        {media && <button data-testid={`${testId}-clear`} aria-label="Remove" onClick={onClear} className="absolute right-1 top-1 rounded-full bg-black/70 p-1"><X size={13} color="#fff" /></button>}
      </div>
      <div className="flex flex-wrap justify-center gap-2">
        <PickBtn icon={Camera} label="Camera" capture onPick={onPick} testId={`${testId}-camera`} />
        <PickBtn icon={Upload} label="Upload" onPick={onPick} testId={`${testId}-upload`} />
      </div>
      <p className="text-center text-[10px] text-neutral-500">Photo or video (up to 60 sec)</p>
    </div>
  );
}
